var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 1.02344L8 8.65314L1 1.02344","stroke":"#323232","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronDown.defaultProps = {"width":"16","height":"10","viewBox":"0 0 16 10","fill":"none"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
